"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const hooks_1 = require("../../shared/hooks");
const icons_1 = require("../../atoms/icons");
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("./types");
const colors_1 = require("../../shared/constants/colors");
const Attachment_1 = require("./Attachment");
const utils_1 = require("./utils");
const MessageFC = ({ message, onRedoClick }) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isOffline } = (0, hooks_1.useNetwork)();
    const messageWrapper = (0, react_1.useRef)(null);
    const [fixedWidth, setFixedWidth] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((_a = message.attachment) === null || _a === void 0 ? void 0 : _a.sizes) {
            setFixedWidth(message.attachment.sizes.medium.size.width >
                (((_b = messageWrapper.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0));
        }
    }, []);
    const hasNoAttachment = !message.attachment;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ClearFloat, {}, void 0), (0, jsx_runtime_1.jsxs)(MessageWrapper, { id: `m_${message.id}`, align: message.align, offline: isOffline, isNew: !message.id, level: message.level, isAttachment: !!message.attachment, ref: messageWrapper, fixedWidth: fixedWidth, children: [((_a = message.attachment) === null || _a === void 0 ? void 0 : _a.sizes) && ((0, jsx_runtime_1.jsx)(Attachment_1.Attachment, { attachment: message.attachment, isError: message.isError, onRedoClick: onRedoClick, modalLabel: (0, utils_1.assembleModalLabel)(message.align === "left", t, message.author, message.label || ""), isOffline: isOffline }, void 0)), message.attachment && !message.attachment.sizes && ((0, jsx_runtime_1.jsx)(Attachment_1.ImageNotFound, { translation: t("common.errors.imageNotFound") }, void 0)), (0, jsx_runtime_1.jsxs)("div", { className: "text-content", children: [(0, utils_1.messagePartToContent)(message.messageParts), (0, jsx_runtime_1.jsxs)(MessageDate, { children: [!message.id && isOffline && hasNoAttachment && ((0, jsx_runtime_1.jsxs)(OfflineInfo, { children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["fas", "exclamation-triangle"], color: "yellow" }, void 0), t("chat.conversation.offlineMessage")] }, void 0)), !message.id && isOffline && hasNoAttachment && (0, jsx_runtime_1.jsx)("span", { children: " - " }, void 0), message.label] }, void 0)] }, void 0)] }, void 0)] }, void 0));
};
const ClearFloat = styled_components_1.default.div `
  clear: both;
`;
const levelColorsMap = {
    [types_1.MessageLevel.INFO]: colors_1.colors.blueLighten80,
    [types_1.MessageLevel.WARN]: colors_1.colors.yellowLighten80
};
const MessageWrapper = styled_components_1.default.div `
  white-space: pre-wrap;
  overflow-wrap: break-word;
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  width: ${({ fixedWidth }) => (fixedWidth ? "90%" : "unset")};
  line-height: 1.25;
  float: ${(props) => props.align};
  margin-bottom: 1rem;

  background-color: ${(props) => props.offline && props.isNew
    ? props.theme.colors.yellowLighten80
    : props.align === "right"
        ? props.theme.colors.silverBase
        : props.theme.colors.whiteBase};

  padding: ${({ theme }) => theme.spacings.xxs};
  border-radius: ${({ theme }) => theme.utils.radius};

  ${({ level }) => level
    ? `
    background-color: ${levelColorsMap[level]};
    border-color: ${levelColorsMap[level]};
    margin: 0 auto 1rem;
  `
    : ""};

  & > a {
    color: ${({ theme }) => theme.colors.blueBase};
  }

  .text-content {
    margin-top: ${({ theme }) => theme.spacings.xs};
    padding: ${({ theme }) => `0 ${theme.spacings.s} ${theme.spacings.s}`};
  }
`;
const MessageDate = styled_components_1.default.div `
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.greyLighten70};
  padding-top: 0.5rem;
`;
const OfflineInfo = styled_components_1.default.span `
  color: ${({ theme }) => theme.colors.yellowBase};
  svg {
    position: relative;
    top: 2px;
  }
`;
exports.default = (0, react_1.memo)(MessageFC);
//# sourceMappingURL=message.js.map